import { render, staticRenderFns } from "./DefectDeliveryUnitChart.vue?vue&type=template&id=18ce8a92&"
import script from "./DefectDeliveryUnitChart.vue?vue&type=script&lang=js&"
export * from "./DefectDeliveryUnitChart.vue?vue&type=script&lang=js&"
import style0 from "./DefectDeliveryUnitChart.vue?vue&type=style&index=0&id=18ce8a92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports